import { css } from "styled-components"

export const SideNavCss = css`
  display: flex;
  grid-area: SideNav;
  flex-direction: column;
  align-items: center;
  width: 50px;
  height: 100vh;
  background-color: var(--blue-dark);
  z-index: 100;
  padding-top: 85px;

  li {
    list-style: none;
    margin-bottom: 30px;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 38px;
    border-radius: 6px;
    background-color: transparent;
    cursor: pointer;
    color: var(--icon-active);
    transition: all 0.3s ease;
    &:hover {
      background-color: var(--icon-active);
      color: var(--white);
    }
    &.active {
      background-color: var(--icon-active);
      color: var(--white);
    }
  }
`
